'use strict';

import Loader from '../loader/loader';
import { isFieldSame, displayErrors, isFieldEmpty } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';
import { carerDetails} from '../carer-detail/carer-detail';


export default class CarerDetailsUpdate {
  	constructor() {
    	let $body = $('body'),
        $updateCarerDetailsDropdown = $('.update-carer-details__dropdown'),
        $firstName = $('#UpdateCarerFirstName'),
        $lastName = $('#UpdateCarerLastName'),
        $primaryNumber = $('#UpdateCarerPrimaryNumber'),
        $secondaryNumber = $('#UpdateCarerSecondaryNumber'),
        $emailAddress = $('#UpdateCarerEmailAddress'),
		$relationshipToClient = $('#UpdateCarerRelationshipToClient'),
        $clientId = $('#ClientId'),
        $primaryContact = $('#PrimaryContact'),
        $updateForm = $('#update-client-form'),
        loader = new Loader(),
        dataParams = {},
		_isInvalid = [],
		currentCarerId;

		//open modal window to update carer details
	    $('.js-expand-carer-details').on('click', function (e) {
	        e.preventDefault();

	        let carerId = $(this).data('carer-id');

	        currentCarerId = carerId;

	        populateCarerModal(carerId);

	        $updateCarerDetailsDropdown.slideDown({
	            duration: 500,
	            easing: 'easeOutExpo',
	            queue: false,
	            complete: function () {
	                $body.addClass('fixed');
	            }
	        });
	    });

	    $('.js-update-carer-details').on('click', function (e) {
	        e.preventDefault();

	        // Define where to display ajax errors
	        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

	        if (isFormValid().length == 0) {
	        	$(this).removeClass('error');

	            loader.fadeIn();

				dataParams = {
					'ClientId': $clientId.val(),
					'Carer': getCarerUpdateDetails()
				};

				$.ajax({
					url: '/api/clients/carer',
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: { __RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val() },
					type: 'PUT',
					data: JSON.stringify(dataParams),
					success: function (data) {
						toaster('Carer details have been saved!');
						window.location.href = data.href;
						loader.fadeOut();

						$errorContainer.slideUp({
							duration: 500,
							easing: 'easeInOutExpo',
							queue: false
						});
					},
					error: function (error) {

						loader.fadeOut();
						displayErrors(error, $errorContainer );
					}
				});
			}
			else
				$(this).addClass('error');
		});

		$('.js-remove-carer-api').on('click', function(e){
			let isMobileDevice = Modernizr.mq('(max-width: 767px)');

			currentCarerId = $(this).data('carer-id');

			$.fancybox.open('#remove-carer', {
	            autoSize: false,
	            closeBtn: false,
	            fitToView: false,
	            height: isMobileDevice == true ? 300 : 200,
	            width: isMobileDevice == true ? 250 : 500,
	            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
	            type: 'inline',
	            wrapCSS: 'modal'
	        });
		});

		$('.js-confirm-remove-carer').on('click', function (e) {
	        e.preventDefault();

	        $.fancybox.close();

	        dataParams = {
	            "ClientId": $clientId.val(),
	            "CarerId": currentCarerId
	        };

	        loader.fadeIn();
	        $.ajax({
	            url: '/api/clients/removecarer',
	            dataType: 'json',
	            contentType: 'application/json; charset=utf-8',
				headers: { __RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val() },
	            type: 'POST',
	            data: JSON.stringify(dataParams),
	            success: function (data) {
	                toaster('Carer has been removed');
	                loader.fadeOut();
	                window.location.href = data.href;
	            },
	            error: function (error) {
	                loader.fadeOut();
	                toaster('Oops, something went wrong.');
	            }
	        });
	    });

	    $('.js-expand-add-carer').on('click', function (e) {
	        e.preventDefault();

	        $('.add-carer-details__dropdown').slideDown({
	            duration: 500,
	            easing: 'easeOutExpo',
	            queue: false,
	            complete: function () {
	                $body.addClass('fixed');
	            }
	        });
	    });

	    $('.js-add-carer-details').on('click', function (e) {
	        e.preventDefault();

	        // Define where to display ajax errors
	        let $errorContainer = $('.view-institution').find('.new-po-number .server-errors__wrap');

	        dataParams = {
	            "ClientId": $clientId.val(),
	            "Carers": carerDetails()
	        };

	        $.ajax({
	            url: '/api/clients/addcarers',
	            dataType: 'json',
	            contentType: 'application/json; charset=utf-8',
				headers: { __RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val() },
	            type: 'POST',
	            data: JSON.stringify(dataParams),
	            success: function (data) {
	            	$errorContainer.slideUp({
	                    duration: 500,
	                    easing: 'easeInOutExpo',
	                    queue: false
	                });
	                toaster('Carer has been added!');
	                loader.fadeOut();

	                window.location.href = data.href;
	            },
	            error: function (error) {
	                loader.fadeOut();

	                displayErrors(error, $errorContainer);
	            }
	        });
	    });

	    //make fields mandatrory if carer is primary contact
	    $('#carer-details__form #PrimaryContact').on('change', function(){
	    	let $this = $(this);

	    	if($this.prop('checked')){
	    		$firstName.attr('required', true);
	    		$lastName.attr('required', true);
	    		$primaryNumber.attr('required', true);
	    	}
	    	else{
	    		$firstName.attr('required', false);
	    		$lastName.attr('required', false);
	    		$primaryNumber.attr('required', false);
	    	}
	    });

	    let populateCarerModal = function(carerId){

			let $currentCarerRow = $(".carer__form[data-carer-id=" + carerId +"]"),
				firstName = $currentCarerRow.data('first-name'),
				lastName = $currentCarerRow.data('last-name'),
				email = $currentCarerRow.find('.CarerEmailAddress').val(),
				primaryNumber = $currentCarerRow.find('.CarerPrimaryNumber').val(),
				secondaryNumber = $currentCarerRow.find('.CarerSecondaryNumber').val(),
				relationshipToClient = $currentCarerRow.find('.CarerRelationshipToClient').attr('relationshipToClientIndex'),
				isPrimary = $currentCarerRow.data('is-primary'),
				currentPrimaryContact = $(".carer__form[data-is-primary='True']").find('h3').text(),
				$primarySwitch = $('#PrimaryContact');

			  $firstName.val(firstName);
		    $lastName.val(lastName);
		    $primaryNumber.val(primaryNumber);
		    $secondaryNumber.val(secondaryNumber);
		    $emailAddress.val(email);
        if(relationshipToClient != "-1"){
          $relationshipToClient.val(relationshipToClient).change();
        }

		    //update checkbox label is carer is not the primary contact person
		    if(isPrimary == 'True'){
				$primarySwitch.prop('checked', true);
		    	$primarySwitch.trigger('change');

		    	$("label[for = PrimaryContact]").text("Is the carer the primary contact person?");
		    }
		    else{
				$primarySwitch.prop('checked', false);
				$primarySwitch.trigger('change');
				if(currentPrimaryContact.length == 0){
					$("label[for = PrimaryContact]").text("Do you want to set this carer as the primary contact?");
				}else{
					$("label[for = PrimaryContact]").text("Do you want to set this carer as the primary contact instead of " + currentPrimaryContact + "?");
				}
			}


		    //trigger events to style inputs
		    $('#carer-details__form input').each( function(){
		    	let $this = $(this);

		    	$this.parent().addClass('focus');
				$this.trigger('blur');
		    });

		};

		let getCarerUpdateDetails = function () {

	        let CarerDetails = {
	        	"Id": currentCarerId,
	            "FirstName": $firstName.val(),
	            "LastName": $lastName.val(),
	            "PrimaryPhoneNumber": $primaryNumber.val(),
	            "SecondaryPhoneNumber": $secondaryNumber.val(),
	            "EmailAddress": $emailAddress.val() == "" ? null : $emailAddress.val(),
				"relationshipToClient": $relationshipToClient.val(),
				"PrimaryContact": $primaryContact.prop('checked')
	        };

		    return CarerDetails;
		};

		let isFormValid = function(){
			var phoneRegEx = /^[0-9]{8,10}$/,
				_isInvalid = [];

			$('#carer-details__form input').each( function(){
		    	let $this = $(this);

		    	if($this.prop('required') && isFieldEmpty($this)){
		    		$this
		                .parent().addClass('incomplete')
		                .find('.error').slideDown({
		                    duration: 500,
		                    easing: 'easeOutExpo',
		                    queue: false
		                });

	            	_isInvalid.push(0);
		    	}
		    	else if($this.is('#UpdateCarerPrimaryNumber') || $this.is('#UpdateCarerSecondaryNumber')){

		    		if(!isFieldEmpty($this) && !$this.val().match(phoneRegEx)){
			    		$this
			                .parent().addClass('incomplete')
			                .find('.error').slideDown({
			                    duration: 500,
			                    easing: 'easeOutExpo',
			                    queue: false
			                });

			            _isInvalid.push(0);
		    		}
		    	}
		    });

	        return _isInvalid;
		};
	}
}
